export default __webpack_public_path__ + "static/clouds-big-f411863c5e474ed853f88a851bbf81b3.png";